<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button type="primary" @click="add" size="small">添加角色</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="150">
            <template slot-scope="scope">
              <!--查看权限-->
              <el-button type="text" @click="showPermission(scope.row)">角色权限</el-button>
              <!--修改-->
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <!--禁用-->
              <el-button class="color-danger" type="text" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <role-operate v-if="roleOperate.visible" :dialog-data="roleOperate" @table-reload="getTableList"/>
    <role-permission v-if="rolePermission.visible" :dialog-data="rolePermission"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import RoleOperate from "./dialog/RoleOperate"
  import RolePermission from "./dialog/RolePermission"
  export default {
    name: "roleList",
    mixins: [PagingData],
    components: {RoleOperate,RolePermission},
    data() {
      return {
        // 统计
        countList: [
          {name: "总记录", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "角色名称", property: "name"},
            {label: "描述", property: "describe"},
            {label: "创建时间", property: "create_at"},
            {label: "修改时间", property: "update_at"},
          ]
        },
        roleOperate: {visible: false, title: "", row: null,width: 450},
        rolePermission: {visible: false, title: "角色权限", row: null, hideBtn: true}
      }
    },
    methods: {
      showPermission(row) {
        this.rolePermission.row = row;
        this.rolePermission.visible = true;
      },
      add() {
        this.roleOperate.title = "添加角色";
        this.roleOperate.visible = true;
        this.roleOperate.row = null;
      },
      revise(row) {
        this.roleOperate.title = "修改角色";
        this.roleOperate.visible = true;
        this.roleOperate.row = JSON.parse(JSON.stringify(row));
      },
      remove(row) {
        this.openConfirm("删除该角色", async ()=> {
          let nv = {};
          nv.optionId = row.id;
          let res = await this.$Http.deleteRole(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      async getTableList() {
        let params = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        let res = await this.$Http.getRoleList(params);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      }
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
